import {
    FEEDBACK_QUALITY_ADD_SUCCESS,
    FEEDBACK_QUALITY_AUTOSAVE_REQUEST,
    FEEDBACK_QUALITY_AUTOSAVE_SUCCESS,
    FEEDBACK_QUALITY_DELETE_SUCCESS,
    FEEDBACK_QUALITY_SUBMIT_REQUEST,
    FEEDBACK_QUALITY_SUBMIT_SUCCESS,
    FEEDBACK_QUALITY_SUBMIT_FAILURE,
    FEEDBACK_QUALITY_GET_SUCCESS,
    AWAIT_FEEDBACK_QUALITY_AUTOSAVE_RESPONSE,
    FEEDBACK_QUALITY_AUTOSAVE_FAILURE,
    CLEAR_AUTOSAVE_NOTIFICATION,
    FEEDBACK_QUALITY_DELETE_FAILURE,
    FEEDBACK_QUALITY_CLOSE_DELETE_DIALOG,
    OTHER_FEEDBACK_READ_SUCCESS
} from './constants';

import {Profile} from 'feedback-system/dto/IProfile';
import {submitFeedback} from '../utils';
import {FeedbacksData} from '../typedef';
import {NewFeedback} from './typedef';

interface State {
    teamData: FeedbacksData[];
    optionalData: FeedbacksData[];
    pending: boolean;
}

interface Action {
    teamData: FeedbacksData[];
    optionalData: FeedbacksData[];
    type: string;
    response: {};
    value: string;
    saveFeedback: NewFeedback;
    payload: {
        recipientId: number | null;
    };
    authenticated: {
        id: number;
        email: string;
        firstName: string;
        lastName: string;
        avatarUrl: string;
        mainTeam: string;
        roles: string[];
    };
    profile: Profile;
    submitedFeedback: number[];
    profileId: number;
    feedbackId: number;
}

const defaultState = {
    teamData: [],
    optionalData: [],
    pending: false,
    deleteUserDialog: false
};

const qualityFeedbackReducer = (state: State = defaultState, action: Action) => {
    switch (action.type) {
        case FEEDBACK_QUALITY_GET_SUCCESS: {
            if (action.teamData) {
                return {
                    ...state,
                    teamData: action.teamData,
                    optionalData: action.optionalData,
                    mockedValue: action.value
                };
            } else {
                return {
                    ...state,
                    optionalData: action.optionalData,
                    mockedValue: action.value
                };
            }
        }
        case FEEDBACK_QUALITY_DELETE_SUCCESS: {
            const resOpt = state.optionalData.filter((user: FeedbacksData) =>
                user.profile.id !== action.payload.recipientId);
            return {
                ...state,
                optionalData: resOpt,
                deleteUserDialog: false
            };
        }
        case FEEDBACK_QUALITY_DELETE_FAILURE: {
            return {
                ...state,
                deleteUserDialog: true
            };
        }

        case FEEDBACK_QUALITY_CLOSE_DELETE_DIALOG: {
            return {
                ...state,
                deleteUserDialog: false
            };
        }

        case AWAIT_FEEDBACK_QUALITY_AUTOSAVE_RESPONSE:
        case FEEDBACK_QUALITY_AUTOSAVE_REQUEST: {
            return {
                ...state,
                pending: true
            };
        }

        case FEEDBACK_QUALITY_AUTOSAVE_SUCCESS: {
            const {optionalData} = state;
            const {teamData} = state;
            const {id, email, firstName, lastName, avatarUrl, mainTeam, roles} = action.authenticated;
            const {
                authorId,
                feedbackId,
                feedbackType,
                periodId,
                recipientId,
                feedbackData
            } = action.saveFeedback;
            const newFeedback: NewFeedback = {
                feedbackId,
                authorId,
                recipientId,
                periodId,
                feedbackType,
                author: {
                    id,
                    email,
                    firstName,
                    lastName,
                    avatarUrl,
                    mainTeam,
                    roles
                },
                feedbackData
            };
            const resOpt = optionalData.map((item: FeedbacksData) => {
                const newProf = {...item};
                if (item.profile.id === recipientId) {
                    newProf.feedbacks = [newFeedback];
                }
                return newProf;
            });
            const resTeam = teamData.map((item: FeedbacksData) => {
                const newProf = {...item};
                if (item.profile.id === recipientId) {
                    newProf.feedbacks = [newFeedback];
                }
                return newProf;
            });
            return {
                ...state,
                saved: true,
                optionalData: resOpt,
                teamData: resTeam,
                pending: false
            };
        }

        case FEEDBACK_QUALITY_AUTOSAVE_FAILURE: {
            return {
                ...state,
                notSaved: true,
                pending: false
            };
        }

        case FEEDBACK_QUALITY_ADD_SUCCESS: {
            const newProfile = {
                profile: action.profile,
                feedbacks: []
            };
            return {
                ...state,
                optionalData: [...state.optionalData, newProfile]
            };
        }

        case FEEDBACK_QUALITY_SUBMIT_REQUEST: {
            return {
                ...state,
                pending: true
            };
        }

        case FEEDBACK_QUALITY_SUBMIT_SUCCESS: {
            const submitedFeedback = action.submitedFeedback;
            return {
                ...state,
                teamData: submitFeedback(state.teamData, submitedFeedback),
                optionalData: submitFeedback(state.optionalData, submitedFeedback),
                pending: false
            };
        }

        case FEEDBACK_QUALITY_SUBMIT_FAILURE: {
            return {
                ...state,
                pending: false
            };
        }

        case CLEAR_AUTOSAVE_NOTIFICATION: {
            return {
                ...state,
                saved: false,
                notSaved: false
            };
        }

        case OTHER_FEEDBACK_READ_SUCCESS: {
            const {profileId} = action;
            const {teamData} = state;
            return {
                ...state,
                teamData: teamData.map(feedback => {
                    if (feedback.feedbacks &&
                        feedback.feedbacks.length &&
                        feedback.feedbacks[0].recipientId === profileId) {
                        return {
                            ...feedback,
                            ...(feedback.otherFeedbackCount ?
                                {otherFeedbackCount: --feedback.otherFeedbackCount} : null)
                        };
                    } else {
                        return feedback;
                    }
                })
            };
        }

        default :
            return state;
    }

};

export {qualityFeedbackReducer};
